import React from 'react';
import {Root} from '@radix-ui/react-accessible-icon';
import styles from './icon-button.module.scss';
import Button from './button';
import classNames from 'classnames';

type IconButtonEl = React.ElementRef<typeof Button>;

interface IconButtonProps {
  children: React.ReactElement;
  label: string;
  className?: string;
  onClick?: () => void;
}

const IconButton = React.forwardRef<IconButtonEl, IconButtonProps>(({
  children,
  label,
  className,
  ...rest
}, forwardedRef) => {
  return (
    <Button
      className={classNames(styles.iconButton, className)}
      size='icon'
      ref={forwardedRef}
      {...rest}
    >
      <Root label={label}>
        {children}
      </Root>
    </Button>
  );
});
IconButton.displayName = 'IconButton';

export default IconButton;
